import { NavLink } from "react-router-dom";
import Breadcumbs from "../components/Breadcumbs";
import { motion } from "framer-motion";
function Decidesermas() {
  return (
    <>
      <div className="margin">
        <Breadcumbs
          content={
            <>
              <NavLink to="/decidesermas">Decide ser más</NavLink>
            </>
          }
        ></Breadcumbs>
      </div>

      <div className="layout8">
     
        <center>
        <h2 className="tag-sermas">
          Te unes al reto de <b>ser más</b>
        </h2>
          <h2>
            Elige una <b>formación de alta calidad</b> que te permita estudiar
            cuando y donde prefieras.{" "}
            <b>
              Vive una experiencia universitaria innovadora y logra tus metas
            </b>{" "}
            académicas con nosotros.
          </h2>
        </center>
        <div >
          <div className="wrapper-contentoffer">
            <motion.div
              initial={{ y: 100, opacity: 0 }}
              whileInView={{
                y: 0,
                opacity: 1,
                transition: {
                  delay: 0.1,
                },
              }}
            >
              <NavLink to="/distancia">
                <img
                  src="https://utpl.edu.ec/recursos/img/img1.webp"
                  alt="utpl"
                ></img>
                <p>Carreras a distancia</p>
              </NavLink>
            </motion.div>

            <motion.div
              initial={{ y: 100, opacity: 0 }}
              whileInView={{
                y: 0,
                opacity: 1,
                transition: {
                  delay: 0.2,
                },
              }}
            >
              <NavLink to="/presencial">
                <img
                  src="https://utpl.edu.ec/recursos/img/img2.webp"
                  alt="utpl"
                ></img>
                <p>Carreras presencial</p>
              </NavLink>
            </motion.div>

            <motion.div
              initial={{ y: 100, opacity: 0 }}
              whileInView={{
                y: 0,
                opacity: 1,
                transition: {
                  delay: 0.3,
                },
              }}
            >
              <NavLink to="/tecnologias">
                <img
                  src="https://utpl.edu.ec/recursos/img/img3.webp"
                  alt="utpl"
                ></img>
                <p>Carreras tecnológicas</p>
              </NavLink>
            </motion.div>

            <motion.div
              initial={{ y: 100, opacity: 0 }}
              whileInView={{
                y: 0,
                opacity: 1,
                transition: {
                  delay: 0.4,
                },
              }}
            >
              <NavLink to="/posgrados">
                <img
                  src="https://utpl.edu.ec/recursos/img/img4.webp"
                  alt="utpl"
                ></img>
                <p>Posgrados</p>
              </NavLink>
            </motion.div>

            <motion.div
              initial={{ y: 100, opacity: 0 }}
              whileInView={{
                y: 0,
                opacity: 1,
                transition: {
                  delay: 0.4,
                },
              }}
            >
              <NavLink to="/formacionpermanente">
                <img
                  src="https://utpl.edu.ec/recursos/img/img5.webp"
                  alt="utpl"
                ></img>
                <p>Formación Permanente</p>
              </NavLink>
            </motion.div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Decidesermas;
